class AVPCProductQuiz extends HTMLElement {
  connectedCallback() {
    this.slides = [...this.querySelectorAll(".rq-slide")];

    this.questions = [
      ...this.querySelectorAll('.rq-slide[data-slide="question"]')
    ];

    this.current = 0;
    this.recommendation = 1;

    this.bindAnswers();
    this.bindButtons();
    this.show(0);
  }

  bindAnswers() {
    this.querySelectorAll(".rq-answer input").forEach((input) => {
      input.addEventListener("change", () => {
        this.calculateRecommendation();

        setTimeout(() => {
          this.show(this.current + 1);
        }, 200);
      });
    });
  }

  bindButtons() {
    this.addEventListener("click", (event) => {
       const addToCartButton = event.target.closest(".rq-add-to-cart");

    if (addToCartButton) {
      event.preventDefault();
      this.addToCart(addToCartButton.dataset.productId);
      return;
    }

      const button = event.target.closest("[data-action]");

      if (!button) return;

      const action = button.dataset.action;

      if (action === "next") {
        this.show(this.current + 1);
      }

      if (action === "back") {
        this.show(this.current - 1);
      }

      if (action === "restart") {
        this.restartQuiz();
      }

      if (action === "submit-details") {
        event.preventDefault();
        this.submitDetails();
      }
    });
  }

  show(index) {
    if (index < 0 || index >= this.slides.length) return;

    this.slides.forEach((slide, i) => {
      slide.classList.toggle("active", i === index);
    });

    this.current = index;

    const questionIndex = this.questions.indexOf(this.slides[index]);

    if (questionIndex >= 0) {
      const progress = this.slides[index].querySelector("[data-progress]");

      if (progress) {
        progress.textContent =
          `Step ${questionIndex + 1} of ${this.questions.length}`;
      }
    }
  }

  calculateRecommendation() {
    const scores = {
      1: 0,
      2: 0,
      3: 0,
      4: 0
    };

    this.querySelectorAll(".rq-answer input:checked").forEach((input) => {
      input.value.split(",").forEach((value) => {
        const product = Number(value.trim());

        if (scores[product] !== undefined) {
          scores[product]++;
        }
      });
    });

    let recommendation = 1;

    Object.keys(scores).forEach((product) => {
      if (scores[product] > scores[recommendation]) {
        recommendation = Number(product);
      }
    });

    this.recommendation = recommendation;
  }

  getRecommendationName() {
    const names = {
      1: "Crisp White",
      2: "Pure Petal",
      3: "Soft Skin",
      4: "Silent Air"
    };

    return names[this.recommendation] || "Crisp White";
  }

  getQuizAnswers() {
    const answers = [];

    this.questions.forEach((question, index) => {
      const checked = question.querySelector(".rq-answer input:checked");

      if (checked) {
        const label = checked.closest(".rq-answer");

        const answerText = label
          ? label.textContent.trim()
          : checked.value;

        answers.push(`Q${index + 1}: ${answerText}`);
      }
    });

    return answers.join(" | ");
  }

  async sendToGoogleForm(name, email, phone) {
    const googleFormUrl =
      "https://docs.google.com/forms/d/e/1FAIpQLSex2iIxDkne1XVYCxgnhEwODZHNA4StfdBnikNoWxVwo-38qw/formResponse";

    const formData = new URLSearchParams();

    formData.append("entry.1954486506", name);
    formData.append("entry.1643410987", email);
    formData.append("entry.1132556499", phone);
    formData.append(
      "entry.1331759187",
      this.getRecommendationName()
    );
    formData.append(
      "entry.880241669",
      this.getQuizAnswers()
    );

    try {
      await fetch(googleFormUrl, {
        method: "POST",
        mode: "no-cors",
        body: formData
      });

      return true;
    } catch (error) {
      console.error("Google Form submission failed:", error);
      return false;
    }
  }

  async submitDetails() {
     const name = this.querySelector('input[name="full_name"]');
  const email = this.querySelector('input[name="email"]');
  const phone = this.querySelector('input[name="phone"]');
    const submitButton = this.querySelector(
      '[data-action="submit-details"]'
    );

    if (!name || !email || !phone) return;

    const nameValue = name.value.trim();
    const emailValue = email.value.trim();
    const phoneValue = phone.value.trim();

    if (!nameValue) {
      name.focus();
      return;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailValue)) {
      email.focus();
      return;
    }

    if (!/^[6-9]\d{9}$/.test(phoneValue)) {
      phone.focus();
      return;
    }

    this.calculateRecommendation();

    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = "Please wait...";
    }

    await this.sendToGoogleForm(
      nameValue,
      emailValue,
      phoneValue
    );

    const result = this.querySelector(
      `.rq-slide[data-slide="result"][data-product="${this.recommendation}"]`
    );

    if (result) {
      this.show(this.slides.indexOf(result));
    }

    if (submitButton) {
      submitButton.disabled = false;
      submitButton.textContent = "See My Recommendation →";
    }
  }
  async addToCart(variantId) {
  const button = this.querySelector(".rq-add-to-cart");

  if (!variantId) return;

  if (button) {
    button.disabled = true;
    button.textContent = "Adding...";
  }

  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        items: [
          {
            id: Number(variantId),
            quantity: 1
          }
        ]
      })
    });

    if (!response.ok) {
      throw new Error("Unable to add product to cart");
    }

    await response.json();

    if (button) {
      button.textContent = "Added to Cart ✓";
    }

    setTimeout(() => {
      window.location.href = "/cart";
    }, 500);

  } catch (error) {
    console.error("Add to cart failed:", error);

    if (button) {
      button.disabled = false;
      button.textContent = "Add to Cart →";
    }
  }
}

  restartQuiz() {
    this.querySelectorAll(".rq-answer input").forEach((input) => {
      input.checked = false;
    });

    const name = this.querySelector("#rumas-quiz-name");
    const email = this.querySelector("#rumas-quiz-email");
    const phone = this.querySelector("#rumas-quiz-phone");

    if (name) name.value = "";
    if (email) email.value = "";
    if (phone) phone.value = "";

    this.recommendation = 1;

    this.show(0);
  }
}

if (!customElements.get("avpc-product-quiz")) {
  customElements.define("avpc-product-quiz", AVPCProductQuiz);
}